export default class AktAnswerResult {
  public readonly id!: string;
  public readonly answer_version_id!: string;
  public readonly subscription_id!: string;
}
